<template>
  <div class="row">
    <div class="service">
      <div class="col-12">
        <div class="article_text">
          <h4>{{ post.title }}</h4>
          <h6>{{ post.description }}</h6>
          <div
            class="article_content"
            v-html="post.content"/>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import rf from '../../communicate/RequestFactory'
  import {errorToaster} from '../../services/ErrorHandler'

  export default {
    name: "ArticleReader",

    data() {
      return {
        post: {},
        post_id: this.$route.params.id
      }
    },

    mounted () {
      this.loadDetailArticle(this.post_id);
    },

    methods: {
      loadDetailArticle(post_id) {
        rf.getRequest("PostRequest").loadDetailArticle(post_id).then((res) => {
          if (res.status === 200) {
            this.post = res.data;
          }
        }).catch(err => {
          errorToaster("Cố vấn Phong Thủy", "Xảy ra lỗi kết nối")
        })
      }
    }
  }
</script>

<style scoped>
  .container img {
    vertical-align: middle;
    border-style: none;
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/article/ArticleReader.vue